import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/editorial-process")({
  beforeLoad: () => {
    throw redirect({ to: "/processo-editorial", statusCode: 301 });
  },
});